<template>
  <div class = "gallery-listing">
    <div class = "gallery-items">
      <div class = "new-project">
        <button class = "btn btn-bg-colored" v-on:click = "createProject()">Crear Nuevo Proyecto</button>
      </div>

      <!--  v-if = "state.user.isLoading" -->
      <gallery-item v-for = "item in myProjects" :key = "item.id" :galleryItem = "item">
        <template v-slot:badge>
          Enviado
          <!--
          <b-icon class="is-finished-icon" v-if="item.is_finished" icon="check-circle"> </b-icon>
          -->
        </template>

        <template v-slot:action>
          <b-dropdown class="project-menu" position="is-bottom-left">
            <a slot="trigger">
              <b-icon icon="dots-vertical"></b-icon>
            </a>
            <b-dropdown-item v-on:click="showSettings(item)"> Configuración</b-dropdown-item>
            <b-dropdown-item v-on:click="confirmCustomDeleteProject(item.id)">Eliminar proyecto</b-dropdown-item>
          </b-dropdown>
        </template>
       </gallery-item>
    </div>

    <!-- createProject -->
    <b-modal :active.sync="editorConfig.isShowingCreateProject" has-modal-card :canCancel="false">
      <editor-create-project></editor-create-project>
    </b-modal>

    <b-modal :active.sync="editorConfig.isShowingSettings" has-modal-card>
      <editor-settings :project = "currentProjectSettings" @save="currentProjectSettings"></editor-settings>
    </b-modal>
  </div>
</template>

<script>
import GalleryItem from '../Gallery/GalleryItem'
import EditorCreateProject from '../Editor/EditorCreateProject'
import EditorSettings from '../Editor/EditorSettings'

export default {
  name: 'Gallery',
  components: {
    GalleryItem,
    EditorCreateProject,
    EditorSettings
  },
  props: {
    searchParams: Object,
    showPaging: {
      default: false
    }
  },
  data () {
    return {
      previousDisabled: true,
      nextDisabled: false,
      currentProjectSettings: null
    }
  },
  watch: {
    '$route': function (oldRoute, newRoute) {
      this.loadGallery()
    }
  },
  computed: {
    myProjects () {
      return this.$store.getters['user/myProjectList']
    },
    numPages () {
      return this.$store.state.gallery.numPages
    },
    galleryItems () {
      return this.$store.state.gallery.fetched
    },
    state () {
      return this.$store.state
    },
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    createProject: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingCreateProject': true})
    },
    confirmCustomDeleteProject: function (projectid) {
      console.log('confirm delet')
      this.$dialog.confirm({
        title: 'Borrar Proyecto',
        message: '¿Estás seguro de que quieres borrar este proyecto? No puedes deshacer esta acción',
        confirmText: 'Borrar proyecto',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          let prom = this.$store.dispatch('deleteProject', projectid)
          prom.then(() => {
            this.$store.dispatch('user/fetchMyProjects')
            this.$toast.open('Proyecto borrado')
          })
          prom.catch((error) => {
            console.log(error)
            this.$toast.open('Error borrando el proyecto')
          })
        }
      })
    },
    showSettings: function (p) {
      console.log('qq')
      this.$store.dispatch('fetchProject', p.id).then((response) => {
        console.log(response)
        this.currentProjectSettings = response.data
        // this.$store.commit('setProject', response.data)
        this.$store.commit('setEditorConfigProperty', {'isShowingSettings': true})
      })
    }
  },
  created () {
    // this.loadGallery()
    this.$store.dispatch('user/fetchMyProjects')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.gallery-listing {
  padding-bottom: 100px;
}

.description {
  font-size: 1.5em;
  padding: 0 15px;
  color: #8c8c8c;
}

.content {
  padding: 20px;
}

.gallery-items {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
  grid-gap: 30px;
  justify-items: center;
}

.loading-wrapper {
  position: relative;
  height: 100px;
}

.pagination {
  display: flex;
  flex-direction: column;
  margin: 30px;

  .pages a {
    color: #555;
    font-weight: 800;
    padding: 5px;

    &:hover, &.selected {
      border-bottom: 3px solid @accentColor;
    }
  }

  & > * {
    padding: 30px;
  }
}

.new-project {
  width: 100%;
  height: 200px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-content: center;
  align-items: center;

  button {
    width: 150px;
    height: 150px;
    margin: 10px auto;
    border-radius: 50%;
    padding: 28px;
    display: flex;
    align-items: center;
  }

  .img {
    outline: 10px solid @accentColor;
    display: flex;
    justify-content: center;
    align-items: center;
    background: @accentColor;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/User/UserProjectListing.vue